import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const ContactInfoThunk = createAsyncThunk(
	'ContactInfo/ContactInfoThunk',
	async (_, ThunkApi) => {
		const { rejectWithValue } = ThunkApi;
		try {
			const res = await axios.get('https://api.act2hf.com/public/settings');

			return res?.data;
		} catch (error) {
			return rejectWithValue(error.response.data);
		}
	},
);
